export const HeaderVariant = {
  Brown30BlackWhiteLogo: 'brown30-black-whiteLogo',
  White20WhiteWhiteLogo: 'white20-white-whiteLogo',
  Brown20BlackWhiteLogo: 'brown20-black-whiteLogo',
  Brown20NoneWhiteLogo: 'brown20-none-whiteLogo',  
  Brown20BlackDarkLogo: 'brown20-black-darkLogo',  
} as const;

export type THeaderVariant = typeof HeaderVariant[keyof typeof HeaderVariant]